// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-57e2c6b4]{font-size:.95rem;color:#757575;text-transform:uppercase;letter-spacing:.05em}.value[data-v-57e2c6b4]{font-size:1rem;font-weight:500;color:#4e0404}", ""]);
// Exports
module.exports = exports;
